import LinkLandingPageOne from "../mockData/images/landing/1.png"
import LinkLandingPageTwo from "../mockData/images/landing/2.png"
import LinkLandingPageThree from "../mockData/images/landing/3.png"
import LinkLandingPageFour from "../mockData/images/landing/4.png"
import LinkLandingPageFive from "../mockData/images/landing/5.png"
import LinkLandingPageSix from "../mockData/images/landing/6.png"
import LinkLandingPageSeven from "../mockData/images/landing/7.png"
import LinkLandingPageEight from "../mockData/images/landing/8.png"
import LinkLandingPageNine from "../mockData/images/landing/9.png"
import LinkLandingPageTen from "../mockData/images/landing/10.png"

const makeSocialLinks = (links) =>
    links.map((link, index) => ({
        order: index,
        platform: link.platform,
        destination_url: link.destination_url,
    }));

const makeFeaturedLinks = (links) =>
    links.map((link, index) => ({
        order: index,
        title: link.title,
        destination_url: link.destination_url,
    }));

const baseLayoutConfig = {
    domain: 1,
    layout: 1,
    font: 26,
    button_corners: 1,
    button_style: 1,
    social_icon_placement: 1,
    social_icon_color: 1,
    background_blurred: false,
    blur_strength: 6,
};

const brandedThemes = {
    richieHawtin: {
        header_color: "#2A2D34",
        body_color: "#0F1115",
        header_color_scheme: 1,
        body_color_scheme: 1,
        title_color: "#F2C14E",
        description_color: "#D5D8DF",
        button_color: "#F2C14E",
        button_text_color: "#F2C14E",
        background_color: "#16191F",
    },
    amelieLens: {
        header_color: "#260B35",
        body_color: "#11071A",
        header_color_scheme: 1,
        body_color_scheme: 1,
        title_color: "#E6CCFF",
        description_color: "#C8B5D9",
        button_color: "#8A2BE2",
        button_text_color: "#8A2BE2",
        background_color: "#1A1025",
    },
    charlotteDeWitte: {
        header_color: "#111111",
        body_color: "#1A1A1A",
        header_color_scheme: 1,
        body_color_scheme: 1,
        title_color: "#F4F4F4",
        description_color: "#C8C8C8",
        button_color: "#D72638",
        button_text_color: "#D72638",
        background_color: "#0D0D0D",
    },
    martinezBrothers: {
        header_color: "#F97316",
        body_color: "#1F2937",
        header_color_scheme: 1,
        body_color_scheme: 1,
        title_color: "#FFFFFF",
        description_color: "#D1D5DB",
        button_color: "#F97316",
        button_text_color: "#F97316",
        background_color: "#111827",
    },
    solomun: {
        header_color: "#BFA46F",
        body_color: "#2E2A24",
        header_color_scheme: 1,
        body_color_scheme: 1,
        title_color: "#F5EBDD",
        description_color: "#D3C6B2",
        button_color: "#BFA46F",
        button_text_color: "#BFA46F",
        background_color: "#211D18",
    },
    deborahDeLuca: {
        header_color: "#FF2D95",
        body_color: "#1A1020",
        header_color_scheme: 1,
        body_color_scheme: 1,
        title_color: "#FFE8F5",
        description_color: "#E8C8DA",
        button_color: "#FF2D95",
        button_text_color: "#FF2D95",
        background_color: "#120B17",
    },
    spotify: {
        header_color: "#1DB954",
        body_color: "#121212",
        header_color_scheme: 1,
        body_color_scheme: 1,
        title_color: "#FFFFFF",
        description_color: "#D9D9D9",
        button_color: "#1DB954",
        button_text_color: "#1DB954",
        background_color: "#191414",
    },
    youtube: {
        header_color: "#000000",
        body_color: "#FFFFFF",
        header_color_scheme: 1,
        body_color_scheme: 1,
        title_color: "#FFFFFF",
        description_color: "#ffffff",
        button_color: "#FF0000",
        button_text_color: "#FF0000",
        background_color: "#F6F6F6",
    },
    amazonMusic: {
        header_color: "#00A8E1",
        body_color: "#0B1220",
        header_color_scheme: 1,
        body_color_scheme: 1,
        title_color: "#EAF8FF",
        description_color: "#C4D9E5",
        button_color: "#00A8E1",
        button_text_color: "#00A8E1",
        background_color: "#121A2A",
    },
    harvardBusinessSchool: {
        header_color: "#A41034",
        body_color: "#f5f2ee",
        header_color_scheme: 1,
        body_color_scheme: 1,
        title_color: "#FFFFFF",
        description_color: "#ece7e1",
        button_color: "#A41034",
        button_text_color: "#A41034",
        background_color: "#ECE7E1",
    },
};

const applyCustomTheme = (name, theme) => ({
    color_scheme: 2,
    premade_color: null,
    custom_color: {
        name,
        ...theme,
        header_gradient: null,
        body_gradient: null,
    },
    ...theme,
    header_gradient: null,
    body_gradient: null,
});

const mockLinkLandingPagesData = [
    {
        ...baseLayoutConfig,
        "id": 1,
        "title": "Richie Hawtin",
        "short_description": "A link-in-bio page for Richie Hawtin",
        "logo": LinkLandingPageOne,
        "full_url": "https://mylnk.io/b/rh",
        "back_url": "rh",
        "created": "2022-02-20T00:00:00",
        ...applyCustomTheme("Richie Hawtin Noir", brandedThemes.richieHawtin),
        "social_links": makeSocialLinks([
            { platform: "instagram", destination_url: "https://instagram.com/richiehawtin" },
            { platform: "youtube", destination_url: "https://youtube.com/@richiehawtin" },
            { platform: "facebook", destination_url: "https://facebook.com/richiehawtinofficial" },
        ]),
        "featured_links": makeFeaturedLinks([
            { title: "Latest Release", destination_url: "https://open.spotify.com/artist/3j4M8vpf4AlxV3YHj9f9vD" },
            { title: "Tour Dates", destination_url: "https://ra.co/dj/richiehawtin" },
        ]),
    },
    {
        ...baseLayoutConfig,
        "id": 2,
        "title": "Amelie Lens",
        "short_description": "A link-in-bio page for Amelie Lens",
        "logo": LinkLandingPageTwo,
        "full_url": "https://mylnk.io/b/al",
        "back_url": "al",
        "created": "2022-05-28T00:00:00",
        ...applyCustomTheme("Amelie Lens Violet", brandedThemes.amelieLens),
        "social_links": makeSocialLinks([
            { platform: "instagram", destination_url: "https://instagram.com/amelielens" },
            { platform: "youtube", destination_url: "https://youtube.com/@amelielens" },
            { platform: "twitter", destination_url: "https://twitter.com/amelielens" },
        ]),
        "featured_links": makeFeaturedLinks([
            { title: "Listen On Spotify", destination_url: "https://open.spotify.com/artist/7K6n4Q0P5h3Rr6j5XQyQx9" },
            { title: "Upcoming Shows", destination_url: "https://ra.co/dj/amelielens" },
        ]),
    },
    {
        ...baseLayoutConfig,
        "id": 3,
        "title": "Charlotte de Witte",
        "short_description": "A link-in-bio page for Charlotte de Witte",
        "logo": LinkLandingPageThree,
        "full_url": "https://mylnk.io/b/cdw",
        "back_url": "cdw",
        "created": "2022-06-08T00:00:00",
        ...applyCustomTheme("Charlotte Industrial", brandedThemes.charlotteDeWitte),
        "social_links": makeSocialLinks([
            { platform: "instagram", destination_url: "https://instagram.com/charlottedewittemusic" },
            { platform: "facebook", destination_url: "https://facebook.com/charlottedewitteofficial" },
            { platform: "youtube", destination_url: "https://youtube.com/@charlottedewitte" },
        ]),
        "featured_links": makeFeaturedLinks([
            { title: "Apple Music", destination_url: "https://music.apple.com/us/artist/charlotte-de-witte/1161921755" },
            { title: "Resident Advisor", destination_url: "https://ra.co/dj/charlottedewitte" },
        ]),
    },
    {
        ...baseLayoutConfig,
        social_icon_color: 3,
        "id": 4,
        "title": "Martinez Brothers",
        "short_description": "A link-in-bio page for Martinez Brothers",
        "logo": LinkLandingPageFour,
        "full_url": "https://mylnk.io/b/mb",
        "back_url": "mb",
        "created": "2022-08-13T00:00:00",
        ...applyCustomTheme("Martinez Sunset", brandedThemes.martinezBrothers),
        "social_links": makeSocialLinks([
            { platform: "instagram", destination_url: "https://instagram.com/themartinezbros" },
            { platform: "facebook", destination_url: "https://facebook.com/themartinezbros" },
            { platform: "twitter", destination_url: "https://twitter.com/themartinezbros" },
        ]),
        "featured_links": makeFeaturedLinks([
            { title: "Beatport Profile", destination_url: "https://www.beatport.com/artist/the-martinez-brothers/33190" },
            { title: "SoundCloud", destination_url: "https://soundcloud.com/themartinezbros" },
        ]),
    },
    {
        ...baseLayoutConfig,
        "id": 5,
        "title": "Solomun",
        "short_description": "A link-in-bio page for Solomun",
        "logo": LinkLandingPageFive,
        "full_url": "https://mylnk.io/b/slmn",
        "back_url": "slmn",
        "created": "2022-08-15T00:00:00",
        ...applyCustomTheme("Solomun Gold", brandedThemes.solomun),
        "social_links": makeSocialLinks([
            { platform: "instagram", destination_url: "https://instagram.com/solomun" },
            { platform: "facebook", destination_url: "https://facebook.com/Solomun" },
            { platform: "youtube", destination_url: "https://youtube.com/@solomunofficial" },
        ]),
        "featured_links": makeFeaturedLinks([
            { title: "Spotify", destination_url: "https://open.spotify.com/artist/5wJK4kN8yA7Qf8Qx3lFfQh" },
            { title: "Tour Tickets", destination_url: "https://www.songkick.com/artists/3603076-solomun" },
        ]),
    },
    {
        ...baseLayoutConfig,
        social_icon_color: 2,
        "id": 6,
        "title": "Deborah De Luca",
        "short_description": "A link-in-bio page for Deborah De Luca",
        "logo": LinkLandingPageSix,
        "full_url": "https://mylnk.io/b/ddl",
        "back_url": "ddl",
        "created": "2022-09-11T00:00:00",
        ...applyCustomTheme("Deborah Neon", brandedThemes.deborahDeLuca),
        "social_links": makeSocialLinks([
            { platform: "instagram", destination_url: "https://instagram.com/deborahdeluca" },
            { platform: "facebook", destination_url: "https://facebook.com/DeborahDeLucaOfficial" },
            { platform: "youtube", destination_url: "https://youtube.com/@deborahdeluca" },
        ]),
        "featured_links": makeFeaturedLinks([
            { title: "Latest Sets", destination_url: "https://soundcloud.com/deborahdelucaofficial" },
            { title: "Discography", destination_url: "https://www.beatport.com/artist/deborah-de-luca/109855" },
        ]),
    },
    {
        ...baseLayoutConfig,
        "id": 7,
        "title": "Spotify",
        "short_description": "Music For Everyone",
        "logo": LinkLandingPageSeven,
        "full_url": "https://mylnk.io/b/SP",
        "back_url": "SP",
        "created": "2022-11-17T00:00:00",
        ...applyCustomTheme("Spotify Green", brandedThemes.spotify),
        "social_links": makeSocialLinks([
            { platform: "instagram", destination_url: "https://instagram.com/spotify" },
            { platform: "facebook", destination_url: "https://facebook.com/Spotify" },
            { platform: "twitter", destination_url: "https://twitter.com/spotify" },
        ]),
        "featured_links": makeFeaturedLinks([
            { title: "Open Web Player", destination_url: "https://open.spotify.com/" },
            { title: "Top 50 Global", destination_url: "https://open.spotify.com/playlist/37i9dQZEVXbMDoHDwVN2tF" },
        ]),
    },
    {
        ...baseLayoutConfig,
        social_icon_color: 3,
        "id": 8,
        "title": "YouTube",
        "short_description": "Broadcast Yourself",
        "logo": LinkLandingPageEight,
        "full_url": "https://mylnk.io/b/YT",
        "back_url": "YT",
        "created": "2023-03-16T00:00:00",
        ...applyCustomTheme("YouTube Red", brandedThemes.youtube),
        "social_links": makeSocialLinks([
            { platform: "instagram", destination_url: "https://instagram.com/youtube" },
            { platform: "facebook", destination_url: "https://facebook.com/youtube" },
            { platform: "twitter", destination_url: "https://twitter.com/youtube" },
        ]),
        "featured_links": makeFeaturedLinks([
            { title: "Trending", destination_url: "https://www.youtube.com/feed/trending" },
            { title: "Music", destination_url: "https://music.youtube.com/" },
        ]),
    },
    {
        ...baseLayoutConfig,
        social_icon_color: 2,
        "id": 9,
        "title": "Amazon Music",
        "short_description": "Stream 100 Million Songs & Podcasts",
        "logo": LinkLandingPageNine,
        "full_url": "https://mylnk.io/b/AM",
        "back_url": "AM",
        "created": "2023-06-10T00:00:00",
        ...applyCustomTheme("Amazon Music Cyan", brandedThemes.amazonMusic),
        "social_links": makeSocialLinks([
            { platform: "instagram", destination_url: "https://instagram.com/amazonmusic" },
            { platform: "facebook", destination_url: "https://facebook.com/AmazonMusic" },
            { platform: "twitter", destination_url: "https://twitter.com/amazonmusic" },
        ]),
        "featured_links": makeFeaturedLinks([
            { title: "Amazon Music", destination_url: "https://music.amazon.com/" },
            { title: "Top Playlists", destination_url: "https://music.amazon.com/playlists" },
        ]),
    },
    {
        ...baseLayoutConfig,
        social_icon_color: 3,
        "id": 10,
        "title": "Harvard Business School",
        "short_description": "A world of difference",
        "logo": LinkLandingPageTen,
        "full_url": "https://mylnk.io/b/hbs",
        "back_url": "hbs",
        "created": "2023-08-25T00:00:00",
        ...applyCustomTheme("HBS Crimson", brandedThemes.harvardBusinessSchool),
        "social_links": makeSocialLinks([
            { platform: "linkedin", destination_url: "https://linkedin.com/school/harvard-business-school/" },
            { platform: "facebook", destination_url: "https://facebook.com/HarvardBusinessSchool" },
            { platform: "youtube", destination_url: "https://youtube.com/@HarvardBusinessSchool" },
        ]),
        "featured_links": makeFeaturedLinks([
            { title: "Programs", destination_url: "https://www.hbs.edu/programs/" },
            { title: "Admissions", destination_url: "https://www.hbs.edu/mba/admissions/" },
        ]),
    }
];
export default mockLinkLandingPagesData;